export default [
  // 预约试驾
  {
    path: '/makeanappointment/makeanappointment-testdrive',
    name: 'makeanappointment',
    component: () =>
      import(/* webpackChunkName: "MaintenanceList" */ '../../views/makeanappointment/makeanappointment.vue'),
    meta: {
      title: '预约试驾',
    },
  },
  {
    path: '/testDrive',
    name: 'testDrive',
    component: () =>
      import(/* webpackChunkName: "MaintenanceList" */ '../../views/makeanappointment/makeanappointment.vue'),
    meta: {
      title: '预约试驾',
    },
  },
]
